import { ReactNode, SyntheticEvent } from 'react';
import { CheckboxVariant } from 'core/flow/entities';
import { Checkbox } from '../../Checkbox';
import { FormControlLabel } from '../../FormControlLabel';
import { TypographyStyled } from './styled';

type CheckboxImageProps = {
  checked: boolean;
  value: string;
  imageSrc?: string;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
};

export const CheckboxImage = ({
  checked,
  value,
  onAnswerClick,
  children,
  imageSrc,
  ...otherProps
}: CheckboxImageProps) => {
  const onChange = (event: SyntheticEvent<Element, Event>, selected: boolean) => {
    onAnswerClick((event.target as HTMLInputElement).value, selected);
  };
  return (
    <>
      <FormControlLabel
        control={<Checkbox />}
        label={null}
        checked={checked}
        onChange={onChange}
        value={value}
        srcImage={imageSrc}
        variant={CheckboxVariant.IMAGE}
        {...otherProps}
      />
      <TypographyStyled variant="bodyLargeRegular">{children}</TypographyStyled>
    </>
  );
};
